import { motion } from "framer-motion";

const links = [
  { label: "Apps", href: "/#apps" },
  { label: "How it works", href: "/#how" },
  { label: "Features", href: "/#features" },
  { label: "Contact", href: "/#contact" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-neutral-200/60"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="/" data-testid="nav-logo" className="flex items-center">
          <img
            src="https://customer-assets-4nw71qhi.emergentagent.net/job_apps-hub-12/artifacts/e6ajbkey_Screenshot%202026-08-16%20at%2011.04.38%20PM.png"
            alt="5ads.ai"
            className="h-10 w-auto mix-blend-multiply"
          />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm text-neutral-600 hover:text-neutral-900 transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="https://social.5ads.ai"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-cta-button"
          className="bg-neutral-900 text-white text-sm font-medium px-5 py-2.5 rounded-full hover:bg-[#FF4D00] transition-colors duration-300"
        >
          Try social.5ads.ai
        </a>
      </div>
    </motion.header>
  );
}
